import React, { useContext } from 'react'
import moment from 'moment'
import { BookingContext, SectionHeader } from './NewBooking'
import AnDateTimePicker from '../../../components/DateTime/DateTimePicker'
import Grid from '@mui/material/Grid'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import { Stack, Typography } from '@mui/material'
import { Place } from '@mui/icons-material'
import { buildAddress } from '../buildAddress'

const ReturnJourney = () => {
  const { formData, handleChange, selectedPatient } = useContext(BookingContext)

  const addressText = (type) => {
    if (formData[type]?.locationType === 'Hospital') {
      return buildAddress(formData?.organisation)
    } else if (formData[type]?.locationType === 'Patient Address') {
      return buildAddress(selectedPatient?.demographics)
    } else {
      return buildAddress(formData[type])
    }
  }

  const returnJourney = formData.returnJourney || {
    required: false,
  }
  const outboundReadyFrom = formData.pickup?.when?.patientReadyFrom
  const returnMinDate =
    outboundReadyFrom && moment(outboundReadyFrom).isValid()
      ? moment(outboundReadyFrom)
      : undefined

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SectionHeader
          icon={<DirectionsCarIcon fontSize="small" />}
          title="Return Journey"
        />
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={returnJourney.required}
              onChange={(e) => {
                handleChange('returnJourney', {
                  ...returnJourney,
                  required: e.target.checked,
                })
              }}
            />
          }
          label="Create return journey"
        />
      </Grid>

      {returnJourney.required && (
        <>
          <Grid item xs={12} lg={6}>
            <Stack gap={1}>
              <Typography variant="title3">Pickup</Typography>
              <Stack gap={1} direction="row" alignItems="center">
                <Place fontSize="small" />
                <Typography variant="body2">
                  {addressText('dropoff')}
                </Typography>
              </Stack>
              <AnDateTimePicker
                label="Return Pickup Time"
                fullWidth
                disablePast
                minDate={returnMinDate}
                date={
                  returnJourney?.pickup?.when?.patientReadyFrom
                    ? moment(returnJourney?.pickup?.when?.patientReadyFrom)
                    : null
                }
                onChange={(val) =>
                  handleChange('returnJourney', {
                    ...returnJourney,
                    pickup: {
                      ...returnJourney.pickup,
                      when: {
                        ...returnJourney?.pickup?.when,
                        patientReadyFrom: val,
                      },
                    },
                  })
                }
              />
            </Stack>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Stack gap={1}>
              <Typography variant="title3">Drop Off</Typography>
              <Stack gap={1} direction="row" alignItems="center">
                <Place fontSize="small" />
                <Typography variant="body2">{addressText('pickup')}</Typography>
              </Stack>
            </Stack>
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default ReturnJourney
